module.exports = __webpack_public_path__ + "img/single_home_banner.19af0353.png";